import { Icon } from '@dx-ui/osc-icon';

const FormSuccessIcon = () => (
  <Icon name="check" variant="solid" className="text-surface-success" />
);

export { FormSuccessIcon };
export default FormSuccessIcon;
